// assets/cart-behavior.js
// =============================================
// Prevents auto-redirect to checkout
// Keeps shopper on the same page
// Updates cart drawer / bubble seamlessly
// =============================================
(function () {
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn, { passive: false });

  // Handle add-to-cart form submissions
  const handleSubmit = async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[type="submit"], .product-form__submit');
    const origText = btn ? btn.textContent : null;
    if (btn) {
      btn.disabled = true;
      btn.classList.add('loading');
    }

    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd
      });
      if (!res.ok) throw new Error('Add to cart failed');
      const line = await res.json();

      // Try to trigger existing cart components
      const drawer = document.querySelector('cart-drawer');
      const notification = document.querySelector('cart-notification');

      if (drawer && typeof drawer.renderContents === 'function') {
        await drawer.renderContents(); // open / refresh cart drawer
      } else if (notification && typeof notification.renderContents === 'function') {
        await notification.renderContents(); // show cart notification
      } else {
        await updateCartCountBubble(); // fallback update
      }
    } catch (err) {
      console.error(err);
      alert('Could not add to cart. Please try again.');
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('loading');
        if (origText) btn.textContent = origText;
      }
    }
  };

  // Update header cart count bubble
  const updateCartCountBubble = async () => {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const cart = await res.json();
    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      bubble.textContent = cart.item_count || 0;
      bubble.style.display = cart.item_count ? 'flex' : 'none';
    }
  };

  // Delegate submits
  on(document, 'submit', handleSubmit);

  // Handle custom buttons that aren’t normal <form> submits
  on(document, 'click', (e) => {
    const btn = e.target.closest(
      '.product-form__submit, [data-add-to-cart], button[name="add"]'
    );
    if (!btn) return;
    const form = btn.closest('form[action="/cart/add"]');
    if (form) handleSubmit({ preventDefault: () => e.preventDefault(), target: btn });
  });
})();
